import React from 'react';
import ReactDOM from 'react-dom';

export class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.modalElement = document.createElement('div');
    this.modalElement.className = `modal ${props.modalClassName}`;
    this.modalRoot = document.getElementById(props.modalRoot);
  }

  componentDidMount() {
    this.modalRoot.appendChild(this.modalElement);
    this.modalShowClassToggle();
  }

  /**
   * 表示されているモーダルのバックグラウンドのスクロールトグル
   */
  toggleBackgroundScroll() {
    const scrollBackground = document.getElementById('infinityscroll-target');
    if (!scrollBackground) {
      return;
    }
    const anyModalDisplayed =
      document.querySelector('#root > .modal.show') !== null;
    scrollBackground.style.overflow = anyModalDisplayed ? 'hidden' : 'auto';
  }

  modalShowClassToggle() {
    if (this.props.modalState) {
      if (!this.modalElement.classList.contains('show')) {
        this.modalElement.classList.add('show');
      }
    } else {
      this.modalElement.classList.remove('show');
    }
    this.toggleBackgroundScroll();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modalState !== this.props.modalState) {
      this.modalShowClassToggle();
    }
  }

  componentWillUnmount() {
    this.modalRoot.removeChild(this.modalElement);
    this.toggleBackgroundScroll();
    if (this.props.onCloseModal) {
      this.props.onCloseModal();
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.modalElement);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.jsx